(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
  var copy = document.querySelector(".logos-slide").cloneNode(true);
  document.querySelector('.logos').appendChild(copy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluto-locations"] && !Shopify.designMode) return;
  try {
    
  let map, markers = [];

  const iconUrls = {
    current:  'https://cdn.shopify.com/s/files/1/0650/2304/9985/files/pluto-location-map-marker.svg?v=1747067450',
    upcoming: 'https://cdn.shopify.com/s/files/1/0650/2304/9985/files/pluto-upcomming-location-map-marker.svg?v=1747067450'
  };

  const locations = [
    {
      lat: 47.9064,
      lng: -97.0459,
      title: "Pluto's Grand Forks",
      state: "North Dakota",
      iconType: "current",
      address: "1440 S Washington St, Grand Forks, ND 58201",
      contact: "(701) 757-1067",
      directions: "https://www.google.com/maps/dir/?api=1&destination=47.9064,-97.0459",
      page: "https://plutosonline.com/pages/plutos-grand-forks"
    },
    {
      lat: 41.1598,
      lng: -104.7962,
      title: "Pluto's Cheyenne",
      state: "Wyoming",
      iconType: "current",
      address: "1829 Dell Range Blvd, Cheyenne, WY 82009",
      contact: "(307) 369-1844",
      directions: "https://www.google.com/maps/dir/?api=1&destination=41.1598,-104.7962",
      page: "https://plutosonline.com/pages/plutos-cheyenne"
    },
    {
      lat: 41.1346,
      lng: -104.8090,
      title: "Pluto's Cheyenne 2",
      state: "Wyoming",
      offset: { lat: 0.001, lng: 0.001 },
      address: "507 E Lincoln Way, Cheyenne, WY 82001",
      contact: "555-9101",
      directions: "https://www.google.com/maps/dir/?api=1&destination=41.1346,-104.8090"
    },
    {
      lat: 42.8498,
      lng: -106.2716,
      title: "Pluto's Casper",
      state: "Wyoming",
      iconType: "current",
      address: "150 SE Wyoming Blvd, Casper, WY 82601",
      contact: "(307) 333-2044",
      page: "https://plutosonline.com/pages/plutos-casper"
    },
    {
      lat: 41.3173,
      lng: -105.5924,
      title: "Pluto's Laramie",
      state: "Wyoming",
      address: "569 N 3rd Street, Laramie, WY 82071",
      contact: "555-3344",
      directions: "https://www.google.com/maps/dir/?api=1&destination=41.3173,-105.5924"
    }
  ];

  window.initMap = async function() {
    // load Maps+marker libs
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

   // Popup overlay
  class Popup extends google.maps.OverlayView {
    constructor(position, contentEl) {
      super();
      this.position = position;
      this.div = document.createElement("div");
      Object.assign(this.div.style, {
        position:     "absolute",
        transform:    "translate(-50%, -100%)",
        background:   "#000",
        color:        "#0fd7df",
        padding:      "0.5em",
        border:       "1px solid #0fd7df",
        borderRadius: "4px",
        fontFamily:   "'Bebas Neue', sans-serif",
        whiteSpace:   "nowrap",
        zIndex:       "2000"
      });
      this.div.appendChild(contentEl);
      Popup.preventMapHitsAndGesturesFrom(this.div);
    }
    onAdd() {
      this.getPanes().floatPane.appendChild(this.div);
    }
    onRemove() {
      this.div.parentNode?.removeChild(this.div);
    }
    draw() {
      const proj  = this.getProjection();
      const pt    = proj.fromLatLngToDivPixel(this.position);
      this.div.style.left = `${pt.x}px`;
      this.div.style.top  = `${pt.y}px`;
    }
  }

  let openPopup = null;
  const bounds     = new google.maps.LatLngBounds();

  // init map
  map = new Map(document.getElementById("map"), {
    center:           { lat: 47.9064, lng: -97.0459 },
    zoom:             7,
    mapId:            "d5a4647ef7d96ca7",
    mapTypeControl:   false,
    fullscreenControl:false,
    streetViewControl:false
  });

  // markers + popups
  markers = locations.map(loc => {
    const pos = {
      lat: loc.lat + (loc.offset?.lat || 0),
      lng: loc.lng + (loc.offset?.lng || 0)
    };
    const type = loc.iconType || (loc.state === "North Dakota" ? "current" : "upcoming");

    // marker icon node
    const img = document.createElement("img");
    img.src             = iconUrls[type];
    img.style.width     = "80px";
    img.style.height    = "80px";
    img.style.userSelect= "none";

    const marker = new AdvancedMarkerElement({
      map,
      position: pos,
      content:  img,
      title:    loc.title,
      zIndex:   type === "current" ? 1000 : 500
    });

    marker.addListener("click", () => {
      // close existing popup
      if (openPopup) openPopup.setMap(null);
      // pan to marker
      map.panTo(marker.position);

      // create content element
      const content = document.createElement("div");
      if (type === "current") {
        // full popup for current stores
        content.innerHTML = `
          <strong style="display:block;font-size:1.1em;margin-bottom:0.4em;">
            ${loc.title}
          </strong>
          <div style="margin-bottom:0.6em;">${loc.contact}</div>
          <button style="
            background:#000;color:#0fd7df;
            border:1px solid #0fd7df;padding:0.4em 0.8em;
            border-radius:3px;font-family:'Montserrat',sans-serif;
            cursor:pointer;
          " onclick="window.open('${loc.page}','_blank')">
            View Location
          </button>
        `;
      } else {
        // simplified for upcoming: only title
        content.innerHTML = `<strong style="display:block;font-size:1.1em;">${loc.title}</strong>`;
      }

      openPopup = new Popup(marker.position, content);
      openPopup.setMap(map);
    });

    bounds.extend(pos);
    return marker;
  });

  // fit bounds
  map.fitBounds(bounds, { padding: 40 });
  google.maps.event.addListenerOnce(map, "bounds_changed", () => {
    if (map.getZoom() > 5.5) map.setZoom(5.5);
  });
};

// load Maps JS API
const script = document.createElement("script");
script.src   = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCt2JuDd-pSK5ZmGXOQrV45YRd37hWrrn8&callback=initMap&v=beta";
script.async = true;
script.defer = true;
document.head.appendChild(script);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluto-promotions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const categories = document.querySelectorAll('.category');
    const contentSections = document.querySelectorAll('.promotion-info');
    const dayLinks = document.querySelectorAll('.day-selector a');
    const promotionItems = document.querySelectorAll('.scheduled-promotion div');
    const promotionHeader = document.querySelector('#scheduled-promotion-header');
    
    // Hide all non-active promotion sections on initial load
    contentSections.forEach(section => {
        if (!section.classList.contains('active')) {
            section.style.opacity = '0';
            section.style.visibility = 'hidden';
            section.style.position = 'absolute';
            section.style.top = '0';
        }
    });

    // CATEGORY SWITCHING SCRIPT
    categories.forEach(category => {
        category.addEventListener('click', function() {
            categories.forEach(cat => cat.classList.remove('active'));
            this.classList.add('active');

            // Hide all sections
            contentSections.forEach(section => {
                section.classList.remove('active');
                section.style.opacity = '0';
                section.style.visibility = 'hidden';
                section.style.position = 'absolute';
                section.style.top = '0';
            });

            // Show the selected section
            const categoryToShow = this.getAttribute('data-category');
            const targetSection = document.getElementById(categoryToShow);
            setTimeout(() => {
                targetSection.classList.add('active');
                targetSection.style.visibility = 'visible';
                targetSection.style.opacity = '1';
                targetSection.style.position = 'relative';
                targetSection.style.top = 'auto';
                updatePromotionDisplay(); // Update based on the category change
            }, 100);
        });
    });

    // Day switching logic
    dayLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const selectedDay = this.getAttribute('data-day');

            // Update promotion header
            updatePromotionHeader(selectedDay);

            // Show only the selected day's promotion
            promotionItems.forEach(item => {
                const itemDay = item.getAttribute('data-day');
                if (itemDay === selectedDay) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });

            // Add 'active' class to the selected d ay link
            dayLinks.forEach(link => link.classList.remove('active'));
            this.classList.add('active');
        });
    });

    // Show only the current day's promotion on initial load
    function updatePromotionDisplay() {
        const today = new Date().getDay(); // 0 = Sunday, 6 = Saturday
        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const currentDay = days[today];

        // Update the header with the current day
        updatePromotionHeader(currentDay);

        // Show only the promotion for the current day
        promotionItems.forEach(item => {
            const itemDay = item.getAttribute('data-day');
            if (itemDay === currentDay) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });

        // Automatically select the correct day link
        const defaultDayLink = document.querySelector(`.day-selector a[data-day="${currentDay}"]`);
        if (defaultDayLink) {
            defaultDayLink.classList.add('active');
        }
    }

    // Update the promotion header with the selected day
    function updatePromotionHeader(selectedDay) {
        if (promotionHeader) {
            const originalHeaderText = promotionHeader.getAttribute('data-original-text') || promotionHeader.textContent.split(' (')[0];
            promotionHeader.setAttribute('data-original-text', originalHeaderText);
            promotionHeader.textContent = originalHeaderText + ` (${selectedDay.charAt(0).toUpperCase() + selectedDay.slice(1)})`;
        }
    }

    // Initial load - call updatePromotionDisplay to show the current day's promotion
    updatePromotionDisplay();
});

// Utility function to check if we're in the Shopify Customizer
function isCustomizer() {
    return window.Shopify && window.Shopify.designMode;
}
  
  } catch(e) { console.error(e); }
})();
})();
